import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, sendEmailVerification, signInWithEmailAndPassword, sendSignInLinkToEmail, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../lib/firebase_auth';


import Modal from '@mui/material/Modal';
import { Container, Typography, Button, Paper, Grid, IconButton, TextField, Box, InputAdornment, Collapse, Alert } from '@mui/material/';

import Link from '@mui/material/Link';
import axios from 'axios';
import GoogleIcon from '@mui/icons-material/Google';

import { getSessionValide, getUserRule, setSession, setEmptySession, getSessionExpirer } from '../../utils/userRule';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import CloseIcon from '@mui/icons-material/Close';

export default function Signup() {

  const URI_Google = process.env.REACT_APP_API + "/auth/google";

  const [email, setEmail] = useState('');
  const [emailReset, setEmailReset] = useState('');

  const [password, setPassword] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenResetPassword, setModalOpenResetPassword] = useState(false);
  const [modalOpenInstructionResetEmailSend, setModalOpenInstructionResetEmailSend] = useState(false);


  const [isSignUp, setIsSignUp] = useState(false);


  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);

  const MyAxios = axios.create({});



  const handleResetPassword = async () => {


      if(emailReset === "")
      {
        alert("Saisir une adresse courriel");
        return;
      }

    const userResetPass = await sendPasswordResetEmail(auth, emailReset).then(() => {
      // Password reset email sent!
    })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
      });

    setEmailReset("");
    setModalOpenInstructionResetEmailSend(true);
    setModalOpenResetPassword(false);
  }


  const handleSignUp = async () => {

    // await auth.createUserWithEmailAndPassword(email, password);
    if (isSignUp) {

      if (password !== confirmPassword) {
        setAlertOpen(true);
        return;
      }
      // Envoi d'un email de vérification à l'utilisateur
      try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);

        //console.log(userCredential);
        await sendEmailVerification(userCredential.user);
        // Optionally sign out the user after registration
        setModalOpen(true);
        setIsSignUp(false);
        auth.signOut();
      } catch (error) {

        console.error('Erreur lors de l\'enregistrement de l\'utilisateur', error);
        if (error.code === 'auth/email-already-in-use') {
          // Gérer l'erreur d'adresse e-mail déjà utilisée ici
          alert("L'adresse courriel saisie est déjà associée à un compte. Veuillez essayer de vous connecter à nouveau plutôt que de créer un nouveau compte.");
          // Autres actions que vous so
        }
      }
    }
    else {

      try {
        await signInWithEmailAndPassword(auth, email, password);
        console.log(auth.currentUser);
        console.log("emailVerified:" + auth.currentUser.emailVerified);
        if (auth.currentUser.emailVerified === true) {
          //******* get encrypt cookie ******** */
          MyAxios.get(process.env.REACT_APP_API + '/auth/protectedalone/' + auth.currentUser.email) //  auth.currentUser.email
            .then((res) => {
              console.log(res);
              if (res.data === null || res.data === "") {
                alert("Vous ne faites pas partie des membres autorisés.");

              }
              else {
                setSession(res.data);
                window.location.href = process.env.REACT_APP_FRONTEND_UI + "/home"
              }
            })
            .catch((error) => {
              console.log("error axios", error);
              if (error.code === 'auth/email-already-in-use') {
                // Gérer l'erreur d'adresse e-mail déjà utilisée ici
                alert("L'adresse courriel saisie est déjà associée à un compte. Veuillez essayer de vous connecter à nouveau plutôt que de créer un nouveau compte.");
                // Autres actions que vous so
              }

            });



        }
        else {

          auth.signOut();
          alert("Votre adresse courriel est introuvable. Veuillez créer un compte.");
        }

        // Si la connexion réussit, vous pouvez rediriger l'utilisateur vers la page souhaitée
        // window.location.href = process.env.REACT_APP_FRONTEND_UI + "/home"

        console.log('Login clicked with email:', email);

        // Handle login logic
      } catch (error) {
        console.error('Erreur lors de la connexion:', error.message);

        // Gérez l'erreur de connexion, par exemple, affichez un message à l'utilisateur
        if (error.code === 'auth/wrong-password') {
          // Le mot de passe est incorrect
          console.log('Mot de passe incorrect. Veuillez réessayer.');
        } else {
          // Autre erreur d'authentification
          console.log('Erreur d\'authentification. Veuillez réessayer.');

        }
        alert('Erreur d\'authentification. Veuillez réessayer.');
      }
    }





  }


  const toggleAuthMode = () => {
    setIsSignUp((prevIsSignUp) => !prevIsSignUp);
  };

  const closeAlert = () => {

    setAlertOpen(false);
  };

  const closeModalOpenInstructionResetEmailSend = () => {
    setModalOpenInstructionResetEmailSend(false);
  };

  const openModalOpenInstructionResetEmailSend = () => {
    setModalOpenInstructionResetEmailSend(true);
  };


  const handleOpenSendResetpass = () => {
    setModalOpenResetPassword(true);
  };


  const handleCloseSendResetpass = () => {
    setModalOpenResetPassword(false);
  };




  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };


  return (


    <>
      <Container maxWidth="md" style={{ marginTop: '50px' }}>
        <Grid container spacing={2}>
          {/* Premier emplacement */}
          <Grid item xs={6}>

            <Paper elevation={3} style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
              <Typography variant="h5">{isSignUp ? 'Créer un compte' : 'Se connecter'}</Typography>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Votre adresse courriel"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              {/* Alert pour afficher un message d'erreur */}


              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Votre mot de passe"
                type={showPassword ? 'text' : 'password'}
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleShowPassword}>
                        {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {isSignUp && (<>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="confirmPassword"
                  label="Confirmez votre mot de passe"
                  type={showPassword ? 'text' : 'password'}
                  id="confirmPassword"
                  autoComplete="current-password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <Collapse in={alertOpen}>
                  <Alert severity="error" onClose={closeAlert}>
                    Les mots de passe ne correspondent pas.
                  </Alert>
                </Collapse>
              </>
              )}
              <Button
                onClick={handleSignUp}
                fullWidth
                 variant="containedFifth"
                 color="primary"
                style={{ marginTop: '20px' }}
              >
                {isSignUp ? 'Créer un compte' : 'Se connecter'}
              </Button>


            </Paper>


          </Grid>

          {/* Deuxième emplacement */}
          <Grid item xs={6}>

            <Paper elevation={3} style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '20px', flex: 1 }}>
              <Typography variant="body1" style={{ fontSize: '1.2rem', marginBottom: '10px' }}>
                {isSignUp
                  ? "S'il s'agit de votre première connexion en tant que dirigeant, vous devez créer un compte pour accéder à la base de données."
                  : "S'il s'agit de votre première connexion en tant que dirigeant, vous devez créer un compte pour accéder à la base de données."}
              </Typography>
              <Link href="#" variant="body2" onClick={toggleAuthMode} style={{ fontSize: '1.3rem' }}>
                {isSignUp ? "Vous avez déjà un compte? "
                  : " Créer un compte "}
              </Link>
            </Paper>

            {!isSignUp ?
              <Paper elevation={3} style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '20px', marginTop: '13px', flex: 1 }}>

                <Button
                  onClick={handleOpenSendResetpass}
                  fullWidth
                  variant="containedFifth"
                 
                  style={{ marginTop: '4px' }}
                >
                  Mot de passe oublié
                </Button>


              </Paper>
              : null
            }


          </Grid>

          {/* Troisième emplacement
          <Grid item xs={12}>

            <Paper elevation={3} style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '20px', flex: 1 }}>
              <Typography variant="body1" style={{ fontSize: '1.2rem', marginTop: '20px', marginBottom: '10px' }}>
                Connexion alternative avec Google comme avant:
              </Typography>
              <Button
                fullWidth
                variant="containedFifth"
                color="primary"
                style={{ marginTop: '10px' }}
                startIcon={<GoogleIcon />}
                href={URI_Google}
              >
                Connexion avec Google
              </Button>
            </Paper>
          </Grid> */}
        </Grid>



        <Modal
          open={modalOpen}
          aria-labelledby="activation-modal-title"
          aria-describedby="activation-modal-description"
        >
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '500px', textAlign: 'center' }}>
            <Typography variant="h6" id="activation-modal-title" gutterBottom>
              Bienvenue!
            </Typography>
            <Typography variant="body1" id="activation-modal-description" style={{ marginBottom: '20px' }}>
              Merci de vous être inscrit. Pour activer votre compte, veuillez suivre ces étapes :
            </Typography>
            <ol style={{ textAlign: 'left' }}>
              <li>
                <strong>Consultez votre boîte de réception :</strong> Vous recevrez un courriel de confirmation à l'adresse que vous avez fournie lors de l'inscription.
              </li>
              <li>
                <strong>Ouvrez le courriel :</strong> Cliquez sur le lien d'activation inclus dans le courriel. Cela activera votre compte.
              </li>
              <li>
                <strong>Connectez-vous :</strong> Une fois votre compte activé, revenez sur le site et connectez-vous en utilisant vos identifiants.
              </li>
            </ol>
            <Button onClick={handleCloseModal} variant="containedFifth" color="primary" style={{ marginTop: '20px' }}>
              Compris, continuer
            </Button>
          </div>
        </Modal>


        <Modal
          open={modalOpenResetPassword}
          aria-labelledby="activation-modal-title"
          aria-describedby="activation-modal-description"
        >

          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '500px', textAlign: 'center' }}>


            <IconButton style={{ float: 'right', borderRadius: '8px', border: '1px solid grey' }}
              edge="end" // Positionnez le bouton à droite
              aria-label="close" // Décrivez l'action pour les lecteurs d'écran
              onClick={handleCloseSendResetpass}
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="h6" id="activation-modal-title" gutterBottom>
              Mot de passe oublié!
            </Typography>


            <Container maxWidth="md" style={{ marginTop: '50px' }}>
              <Grid container spacing={2}>


                {/* Premier emplacement */}
                <Grid item xs={12}>

                  <Paper elevation={3} style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Votre adresse courriel"
                      name="email"
                      autoComplete="email"
                      autoFocus
                      value={emailReset}
                      onChange={(e) => setEmailReset(e.target.value)}
                    />


                    <Button
                      onClick={handleResetPassword}
                      fullWidth
                      variant="containedFifth"
                      color="primary"
                      style={{ marginTop: '20px' }}
                    >
                      Réinitialiser le mot de passe
                    </Button>


                  </Paper>


                </Grid>

              </Grid>
            </Container>
          </div>

        </Modal>


        <Modal
          open={modalOpenInstructionResetEmailSend}
          aria-labelledby="activation-modal-title"
          aria-describedby="activation-modal-description"
        >
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '500px', textAlign: 'center' }}>
            <Typography variant="h6" id="activation-modal-title" gutterBottom>
              Réinitialisation de mot de passe
            </Typography>
            <Typography variant="body1" id="activation-modal-description" style={{ marginBottom: '20px' }}>
              Pour complété le changement de mot de passe, veuillez suivre ces étapes :
            </Typography>
            <ol style={{ textAlign: 'left' }}>
              <li>
                <strong>Consultez votre boîte de réception :</strong> Vous recevrez un courriel de réinitialisation de mot de passe à l'adresse que vous venez de fournir.
              </li>
              <li>
                <strong>Ouvrez le courriel :</strong> Cliquez sur le lien fourni dans le courriel. Cela vous dirigera vers une nouvelle page web où vous pourrez saisir votre nouveau mot de passe.
              </li>
              <li>
                <strong>Connectez-vous :</strong> Une fois que vous avez changé votre mot de passe, retournez sur le site et connectez-vous en utilisant vos informations d'identification habituelles.
              </li>
            </ol>
            <Button onClick={closeModalOpenInstructionResetEmailSend} variant="containedFifth" color="primary" style={{ marginTop: '20px' }}>
              Compris, continuer
            </Button>






          </div>
        </Modal>

      </Container >

    </>
  )
}

